// TrainsData.js — All static data for the Trains page

import { Moon, Sun, Sunrise, Sunset } from "lucide-react";

export const trainsData = [
  {
    id: 1,
    name: "Ndls Cnb Sht",
    number: "12034",
    type: "Shatabdi",
    typeCode: "SHT",
    runsOn: ["S", "M", "T", "W", "T", "F", "S"],
    departure: "03:40",
    departureTime24: 15.67,
    departureCity: "New Delhi",
    arrival: "08:50",
    arrivalTime24: 20.83,
    arrivalCity: "Kanpur Central",
    duration: "5h 10m",
    durationMins: 310,
    departureSlot: "12to18",
    arrivalSlot: "18to24",
    isTatkal: true,
    isPremiumTatkal: false,
    classes: [
      { code: "CC", label: "AC Chair Car", isTatkal: true, price: 1330, available: 57, waitlist: null },
      { code: "CC", label: "AC Chair Car", isTatkal: false, price: 1010, available: 605, waitlist: null },
      { code: "EC", label: "Executive Chair", isTatkal: true, price: 2345, available: 5, waitlist: null },
      { code: "EC", label: "Executive Chair", isTatkal: false, price: 1890, available: 23, waitlist: null },
    ],
    updatedAgo: "30 mins ago",
    tags: ["premium", "fast"],
  },
  {
    id: 2,
    name: "IRCTC Tejas Exp",
    number: "82502",
    type: "Tejas Express",
    typeCode: "TEJ",
    runsOn: ["S", "M", "T", "W", "T", "F", "S"],
    departure: "03:30",
    departureTime24: 15.5,
    departureCity: "New Delhi",
    arrival: "08:35",
    arrivalTime24: 20.58,
    arrivalCity: "Kanpur Central",
    duration: "5h 05m",
    durationMins: 305,
    departureSlot: "12to18",
    arrivalSlot: "18to24",
    isTatkal: true,
    isPremiumTatkal: false,
    classes: [
      { code: "CC", label: "AC Chair Car", isTatkal: true, price: 1638, available: 300, waitlist: null },
      { code: "CC", label: "AC Chair Car", isTatkal: false, price: 1749, available: 189, waitlist: null },
      { code: "EC", label: "Executive Chair", isTatkal: false, price: 2163, available: 46, waitlist: null },
      { code: "EC", label: "Executive Chair", isTatkal: true, price: 2540, available: 12, waitlist: null },
    ],
    updatedAgo: "2 hrs ago",
    tags: ["premium", "fast", "tatkal"],
  },
  {
    id: 3,
    name: "Prayagraj Exp",
    number: "12418",
    type: "Superfast",
    typeCode: "SF",
    runsOn: ["S", "M", "T", "W", "T", "F", "S"],
    departure: "10:10",
    departureTime24: 22.17,
    departureCity: "New Delhi",
    arrival: "03:50",
    arrivalTime24: 3.83,
    arrivalCity: "Kanpur Central",
    duration: "5h 40m",
    durationMins: 340,
    departureSlot: "18to24",
    arrivalSlot: "0to6",
    isTatkal: true,
    isPremiumTatkal: true,
    classes: [
      { code: "2A", label: "AC 2 Tier", isTatkal: true, price: 1610, available: 10, waitlist: null },
      { code: "SL", label: "Sleeper", isTatkal: true, price: 440, available: null, waitlist: "TQWL 21" },
      { code: "SL", label: "Sleeper", isTatkal: false, price: 315, available: null, waitlist: "PQWL 38" },
      { code: "3A", label: "AC 3 Tier", isTatkal: true, price: 1010, available: null, waitlist: "TQWL 3" },
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 785, available: 22, waitlist: null },
    ],
    updatedAgo: "2 hrs ago",
    tags: ["tatkal", "budget"],
  },
  {
    id: 4,
    name: "Kalindi Express",
    number: "14723",
    type: "Express",
    typeCode: "EXP",
    runsOn: ["S", "M", "W", "F", "S"],
    departure: "06:20",
    departureTime24: 6.33,
    departureCity: "New Delhi",
    arrival: "12:45",
    arrivalTime24: 12.75,
    arrivalCity: "Kanpur Central",
    duration: "6h 25m",
    durationMins: 385,
    departureSlot: "6to12",
    arrivalSlot: "12to18",
    isTatkal: false,
    isPremiumTatkal: false,
    classes: [
      { code: "SL", label: "Sleeper", isTatkal: false, price: 260, available: 142, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 720, available: 34, waitlist: null },
      { code: "2A", label: "AC 2 Tier", isTatkal: false, price: 1050, available: 8, waitlist: null },
      { code: "2S", label: "Second Sitting", isTatkal: false, price: 140, available: 88, waitlist: null },
    ],
    updatedAgo: "5 hrs ago",
    tags: ["budget"],
  },
  {
    id: 5,
    name: "Swatantrata S Exp",
    number: "12559",
    type: "Superfast",
    typeCode: "SF",
    runsOn: ["M", "T", "W", "T", "F"],
    departure: "06:35",
    departureTime24: 6.58,
    departureCity: "New Delhi",
    arrival: "12:15",
    arrivalTime24: 12.25,
    arrivalCity: "Kanpur Central",
    duration: "5h 40m",
    durationMins: 340,
    departureSlot: "6to12",
    arrivalSlot: "12to18",
    isTatkal: true,
    isPremiumTatkal: false,
    classes: [
      { code: "SL", label: "Sleeper", isTatkal: false, price: 290, available: 76, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 780, available: 19, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: true, price: 1005, available: 6, waitlist: null },
      { code: "2A", label: "AC 2 Tier", isTatkal: false, price: 1120, available: 4, waitlist: null },
      { code: "1A", label: "AC First Class", isTatkal: false, price: 1980, available: 2, waitlist: null },
    ],
    updatedAgo: "1 hr ago",
    tags: ["fast", "tatkal"],
  },
  {
    id: 6,
    name: "Garib Rath Exp",
    number: "12216",
    type: "Garib Rath",
    typeCode: "GR",
    runsOn: ["T", "F", "S"],
    departure: "10:55",
    departureTime24: 22.92,
    departureCity: "New Delhi",
    arrival: "04:20",
    arrivalTime24: 4.33,
    arrivalCity: "Kanpur Central",
    duration: "5h 25m",
    durationMins: 325,
    departureSlot: "18to24",
    arrivalSlot: "0to6",
    isTatkal: false,
    isPremiumTatkal: false,
    classes: [
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 535, available: 64, waitlist: null },
      { code: "SL", label: "Sleeper", isTatkal: false, price: 195, available: 210, waitlist: null },
    ],
    updatedAgo: "7 hrs ago",
    tags: ["budget", "garib-rath"],
  },
  {
    id: 7,
    name: "Rajdhani Express",
    number: "12302",
    type: "Rajdhani",
    typeCode: "RAJ",
    runsOn: ["S", "M", "T", "W", "T", "F", "S"],
    departure: "04:55",
    departureTime24: 16.92,
    departureCity: "New Delhi",
    arrival: "09:55",
    arrivalTime24: 21.92,
    arrivalCity: "Kanpur Central",
    duration: "5h 00m",
    durationMins: 300,
    departureSlot: "12to18",
    arrivalSlot: "18to24",
    isTatkal: false,
    isPremiumTatkal: true,
    classes: [
      { code: "1A", label: "AC First Class", isTatkal: false, price: 2975, available: 4, waitlist: null },
      { code: "2A", label: "AC 2 Tier", isTatkal: false, price: 1755, available: 11, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 1205, available: 38, waitlist: null },
    ],
    updatedAgo: "45 mins ago",
    tags: ["premium", "fast", "rajdhani"],
  },
  {
    id: 8,
    name: "Unchahar Express",
    number: "14211",
    type: "Express",
    typeCode: "EXP",
    runsOn: ["S", "T", "W", "S"],
    departure: "11:10",
    departureTime24: 23.17,
    departureCity: "New Delhi",
    arrival: "05:30",
    arrivalTime24: 5.5,
    arrivalCity: "Kanpur Central",
    duration: "6h 20m",
    durationMins: 380,
    departureSlot: "18to24",
    arrivalSlot: "0to6",
    isTatkal: true,
    isPremiumTatkal: false,
    classes: [
      { code: "2S", label: "Second Sitting", isTatkal: false, price: 135, available: 312, waitlist: null },
      { code: "SL", label: "Sleeper", isTatkal: false, price: 245, available: 95, waitlist: null },
      { code: "SL", label: "Sleeper", isTatkal: true, price: 415, available: 14, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 665, available: 27, waitlist: null },
    ],
    updatedAgo: "3 hrs ago",
    tags: ["budget", "tatkal"],
  },
  {
    id: 9,
    name: "Gomti Express",
    number: "12419",
    type: "Superfast",
    typeCode: "SF",
    runsOn: ["S", "M", "T", "W", "T", "F", "S"],
    departure: "06:10",
    departureTime24: 6.17,
    departureCity: "New Delhi",
    arrival: "11:40",
    arrivalTime24: 11.67,
    arrivalCity: "Kanpur Central",
    duration: "5h 30m",
    durationMins: 330,
    departureSlot: "6to12",
    arrivalSlot: "6to12",
    isTatkal: false,
    isPremiumTatkal: false,
    classes: [
      { code: "CC", label: "AC Chair Car", isTatkal: false, price: 890, available: 55, waitlist: null },
      { code: "SL", label: "Sleeper", isTatkal: false, price: 270, available: 130, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: false, price: 730, available: 41, waitlist: null },
    ],
    updatedAgo: "1 hr ago",
    tags: ["fast"],
  },
  {
    id: 10,
    name: "Special Tatkal Exp",
    number: "04023",
    type: "Special Tatkal",
    typeCode: "ST",
    runsOn: ["M", "W", "F"],
    departure: "11:45",
    departureTime24: 23.75,
    departureCity: "New Delhi",
    arrival: "05:00",
    arrivalTime24: 5.0,
    arrivalCity: "Kanpur Central",
    duration: "5h 15m",
    durationMins: 315,
    departureSlot: "18to24",
    arrivalSlot: "0to6",
    isTatkal: true,
    isPremiumTatkal: true,
    classes: [
      { code: "SL", label: "Sleeper", isTatkal: true, price: 490, available: 20, waitlist: null },
      { code: "3A", label: "AC 3 Tier", isTatkal: true, price: 1100, available: 8, waitlist: null },
      { code: "2A", label: "AC 2 Tier", isTatkal: true, price: 1650, available: 3, waitlist: null },
    ],
    updatedAgo: "30 mins ago",
    tags: ["tatkal", "special"],
  },
];

export const classOptions = [
  { code: "SL", label: "Sleeper - SL" },
  { code: "2S", label: "Second Sitting - 2S" },
  { code: "CC", label: "AC Chair Car - CC" },
  { code: "3E", label: "AC 3 Tier Economy - 3E" },
  { code: "3A", label: "AC 3 Tier - 3A" },
  { code: "2A", label: "AC 2 Tier - 2A" },
  { code: "1A", label: "AC First Class - 1A" },
  { code: "EC", label: "Executive Chair Car - EC" },
];

export const trainTypeOptions = [
  { code: "ST", label: "Special Tatkal Trains - ST" },
  { code: "SP", label: "Special Trains - SP" },
  { code: "GR", label: "Garib Rath - G" },
  { code: "RAJ", label: "Rajdhani - RAJ" },
  { code: "SHT", label: "Shatabdi - SHT" },
  { code: "TEJ", label: "Tejas Express - TEJ" },
  { code: "SF", label: "Superfast - SF" },
  { code: "EXP", label: "Express - EXP" },
];

export const timeSlots = [
  {
    value: "0to6",
    label: "12am – 6am",
    icon: Moon
  },
  {
    value: "6to12",
    label: "6am – 12pm",
    icon: Sunrise
  },
  {
    value: "12to18",
    label: "12pm – 6pm",
    icon: Sun
  },
  {
    value: "18to24",
    label: "6pm – 12am",
    icon: Sunset
  }
];